import React from 'react';
import styled from 'styled-components';

import { WithSearch, SearchBox } from '@elastic/react-search-ui';

import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';
import Input from '@material-ui/core/Input';

import SearchIcon from 'mdi-material-ui/Magnify';

import CustomAutocomplete from 'components/Search/CustomAutocomplete';

const SearchInput = styled(Input)`
  font-size: ${props => (props.size === 'large' ? `1.5em` : `inherit`)};
`;

const SearchProgress = styled(CircularProgress)`
  padding: 10px;
`;

const CustomSearchBox = styled(
  ({ autoFocusInput, size, placeholder = 'Search...', ...other }) => (
    <SearchBox
      onSelectAutocomplete={selection => {
        window.location.href = selection.url.raw;
      }}
      shouldClearFilters={false}
      autocompleteView={props => <CustomAutocomplete {...props} />}
      inputView={({ getAutocomplete, getInputProps, getButtonProps }) => (
        <>
          <SearchInput
            autoFocus={autoFocusInput}
            size={size}
            type="search"
            endAdornment={
              <InputAdornment position="end">
                <WithSearch
                  mapContextToProps={({ isLoading }) => ({ isLoading })}
                >
                  {({ isLoading }) => (
                    <>
                      {isLoading ? (
                        <SearchProgress />
                      ) : (
                        <IconButton edge="end" {...getButtonProps()}>
                          <SearchIcon />
                        </IconButton>
                      )}
                    </>
                  )}
                </WithSearch>
              </InputAdornment>
            }
            {...getInputProps({
              placeholder: placeholder
            })}
            fullWidth
          />
          {getAutocomplete()}
        </>
      )}
      {...other}
    />
  )
)`
  position: relative;
  input::-webkit-search-cancel-button {
    -webkit-appearance: none;
    cursor: pointer;
    width: 24px;
    height: 24px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' style='width:24px;height:24px' viewBox='0 0 24 24'%3E%3Cpath fill='rgba(0, 0, 0, 0.65)' d='M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z' /%3E%3C/svg%3E");
  }
`;

export default CustomSearchBox;
